// FeedCardSkeleton.jsx
import React from 'react';
import { Paper, Grid, Box, Stack, Skeleton } from '@mui/material';

const FeedSingleSkeleton = () => (
  <Paper
    sx={{
      p: 1,
      borderRadius: '12px',
    //   boxShadow: '0px 4px 12px rgba(0,0,0,0.1)',
      width: '100%',
      background:'transparent',
      minHeight: '75vh',
    }}
  >
    <Grid container spacing={2}>
      {/* Image + Thumbnails */}
      <Grid item xs={8}>
        {/* Main image */}
        <Skeleton
          variant="rectangular"
          width="100%"
          height={350}
          sx={{ borderRadius: '12px', mb: 1 }}
          animation="wave"
        />

        {/* Thumbnail row */}
        <Stack direction="row" spacing={1}>
          {[...Array(4)].map((_, idx) => (
            <Skeleton
              key={idx}
              variant="rectangular"
              width={64}
              height={64}
              sx={{ borderRadius: '8px' }}
              animation="wave"
            />
          ))}
        </Stack>
      </Grid>

      {/* Comments list */}
      <Grid item xs={4}>
        {[...Array(3)].map((_, i) => (
          <Box key={i} sx={{ mb: 2 }}>
            {/* Comment header */}
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <Skeleton variant="circular" width={40} height={40} animation="wave" />
              <Skeleton variant="text" width="30%" height={20} sx={{ ml: 1 }} animation="wave" />
              <Skeleton variant="text" width="15%" height={20} sx={{ ml: 'auto' }} animation="wave" />
            </Box>

            {/* Comment text */}
            <Skeleton variant="text" width="80%" height={20} animation="wave" />

            {/* Comment actions (like/reply) */}
            <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
              <Skeleton variant="text" width="10%" height={20} animation="wave" />
              <Skeleton variant="text" width="10%" height={20} animation="wave" />
            </Box>
          </Box>
        ))}
      </Grid>
    </Grid>
  </Paper>
);

export default FeedSingleSkeleton;
